import { getAllEnrolledUnits } from '../services/vu'
import { setPageToDisplay } from '../actions/enrolmentContainer'
import { getYearsEnrolled } from '../helpers/enrolment'

export const fetchUnitsIfNeeded = (courseId, parentSSPNo) => {
  return (dispatch, getState) => {
    if (shouldFetchUnits(getState(), courseId)) {
      return dispatch(fetchUnits(courseId, parentSSPNo))
    } else {
      let units = getState().units[courseId].items
      dispatch(setPageToDisplay(units.length > 0 ? getYearsEnrolled(units)[0] : "NOW"))
      return Promise.resolve()
    }
  }
}

const shouldFetchUnits = (state, courseId) => {
  const { isFetching, receivedAt } = state.units[courseId]
  return receivedAt === null && !isFetching
}

const fetchUnits = (courseId, parentSSPNo) => {
  return dispatch => {
    dispatch(requestUnits(courseId))

    return getAllEnrolledUnits(parentSSPNo).then(enrolledUnits => {
      const units = enrolledUnits
            .filter(({ unitStage, unitStatus }) => {
          return (
              (unitStage === 'ENR' &&  unitStatus === 'ENR') ||
              (unitStage === 'COMP' &&  unitStatus === 'PASS') ||
              (unitStage === 'COMP' &&  unitStatus === 'FAIL')
          )
        })

      dispatch(setPageToDisplay(units.length > 0 ? getYearsEnrolled(units)[0] : "NOW"))

      return dispatch(receiveUnits(courseId, units))
    })
  }
}

const requestUnits = courseId => {
  return {
    type: 'REQUEST_UNITS',
    courseId
  }
}

const receiveUnits = (courseId, units) => {
  return {
    type: 'RECEIVE_UNITS',
    courseId,
    units
  }
}
